import { useEffect, useState } from "react";
import useAuth from "./useAuth";
import useLoggedIn from "./useLoggedIn";
import { isFakeAuthEnabled } from "../config/fakeAuth";

/**
 * Estado de sesión listo para pintar UI.
 *
 * Centraliza lo que antes repetían Nav, ProductGrid y Product: valida el token
 * contra el servidor al montar y avisa si además hay `userProfileData`, que es
 * lo que habilita la lista de precios.
 *
 * Ojo: en el primer render (SSR incluido) `isAuthenticated` es `false`; recién
 * después del efecto pasa a `true`. Por eso la home pública es la que se
 * renderiza primero y la de cliente entra al hidratar.
 */
const useSession = () => {

	const { auth } = useAuth();
	const isLoggedIn = useLoggedIn();
	const [isAuthenticated, setIsAuthenticated] = useState(Boolean(auth?.user));
	const [hasPriceList, setHasPriceList] = useState(false);

	useEffect(() => {
		let isMounted = true;

		const checkIfLoggedIn = async () => {
			const loggedIn = await isLoggedIn();
			if (isMounted && loggedIn) {
				setIsAuthenticated(true);
			}
		};

		// Sesión simulada: el contexto ya trae usuario, no hay servidor al que preguntar
		isFakeAuthEnabled() ? setIsAuthenticated(true) : checkIfLoggedIn();

		return () => isMounted = false;
	}, []);

	useEffect(() => {
		setIsAuthenticated(Boolean(auth?.user));
		setHasPriceList(window.localStorage.getItem("userProfileData") !== null);
	}, [auth]);

	return { isAuthenticated, hasPriceList };
};

export default useSession;
